export const CAMPAIGN_MANAGER_ROLES = ['admin_level_4', 'admin_level_11'];

export const canAccessCampaignManager = (role) => CAMPAIGN_MANAGER_ROLES.includes(role);
